module.exports = __webpack_public_path__ + "static/media/picture-landscape.92dcf5aa.svg";